import {
	Component,
	ElementRef,
	ViewChild,
	HostListener,
	OnInit,
	AfterViewChecked,
	OnDestroy
} from '@angular/core';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Message } from 'src/app/shared/models/message';
import { User } from 'src/app/shared/models/security/user';
import { CookieService } from 'ngx-cookie-service';
import { MessageNotification } from 'src/app/shared/models/message-notification';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Conversation } from 'src/app/shared/models/messaging/conversation';
import { MobileMessagerieComponent } from './mobile/mobile-messagerie/mobile-messagerie.component';
import { BrowserMessagerieComponent } from './browser/browser-messagerie/browser-messagerie.component';
import { LogService } from 'src/app/core/services/log/log.service';

@Component({
	selector: 'app-messagerie',
	templateUrl: './messagerie.component.html',
	styleUrls: ['./messagerie.component.scss']
})
export class MessagerieComponent implements OnInit, OnDestroy {
	@HostListener('document:mousewheel', ['$event'])
	currentUser: User;
	isScrollNeeded = true;
	isSendButtonDisabled = false;

	usersForNewConversation: User[] = [];
	conversations: Conversation[] = [];
	notifications: MessageNotification[] = [];
	isMobile = false;
	screenWidth: number;

	@ViewChild('mobileMessagerie') mobileMessagerieRef: MobileMessagerieComponent;
	@ViewChild('browserMessagerie')
	browserMessagerieRef: BrowserMessagerieComponent;

	constructor(private facade: FacadeService, private logService: LogService) {}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isScrollNeeded = true;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.currentUser = this.facade.dataStorageService.getUser();
		this.getMessageNotification(this.currentUser);
		this.getAllConversations();
		this.getAllUsersForConversation();
	}

	getAllConversations() {
		this.facade.userService
			.getAllExistingConversations()
			.subscribe((conversationList: Conversation[]) => {
				this.conversations = conversationList;
			});
	}

	getAllUsersForConversation() {
		this.facade.userService.getAllUsersForMessaging().subscribe({
			next: (users: User[]) => {
				this.usersForNewConversation = users;
			},
			error: (err: any) => {
				this.logService.log(err);
			}
		});
	}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	onMouseWheel(e) {
		this.isScrollNeeded = false;
	}

	// Envoyer un message
	sendMessage(message: Message): void {
		this.isSendButtonDisabled = true;
		this.facade.messageService.addMessage(message).subscribe(
			(_) => {
				this.isScrollNeeded = true;
				this.isSendButtonDisabled = false;
				if (this.isMobile) {
					this.mobileMessagerieRef.messageReachedBackConfirmed(message);
				} else {
					this.browserMessagerieRef.messageReachedBackConfirmed(message);
				}
			},
			(err: ErrorResponse) => {
				this.isSendButtonDisabled = false;
				this.facade.toastService.createErrorToast(
					'Une erreur est survenue. Veuillez réessayer.'
				);
			}
		);
	}

	getMessageNotification(user: User): void {
		// this.facade.notificationService
		// 	.getMessageNotifications(user.id)
		// 	.subscribe((notification: MessageNotification[]) => {
		// 		this.notifications = notification;
		// 	});
	}

	ngOnDestroy(): void {
		this.facade.messageService.ngOnDestroy();
	}
}
